import UpdateVoiceFileRequest from '../../../../../Spirit/Admin/Interfaces/Models/UpdateVoiceFileRequest';

export default class UpdateSleepStoryTranslationRequest  {
	LangCode?: string = '';
	Name?: string = '';
	Description?: string = '';
	VoiceFile: UpdateVoiceFileRequest = null;
	constructor(obj?: Partial<UpdateSleepStoryTranslationRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
